import "./CreateStoreModal.css";
import PopUp from "../../components/PopUp";
import { Button } from "../../components/forms/Form";

export default function DeleteStoreModal(props) {
  return (
    <div className="create-store-container">
      <PopUp handleSubmit={props.togglePopUp} title={props.title}>
        <div style={{ backgroundColor: "#fff" }} className="create-store-form">
          <div style={{ display: "flex", alignItems: "center" }}>
            <p
              style={{
                fontSize: 20,
                marginBottom: 0,
                color: "black",
                textAlign: "center",
                padding: "16px 0",
              }}
            >
              Sei sicuro di voler cancellare lo store? <br /> Non potrai più
              tornare indietro
            </p>
          </div>
          <div className="create-store-button-container">
            <Button
              text={"ANNULLA"}
              className={"nodelete-button"}
              handleSubmit={() => props.togglePopUp()}
            />
            <Button
              text={"ELIMINA"}
              className={"delete-button"}
              loading={props.loading}
              handleSubmit={props.handleSubmit}
            />
          </div>
        </div>
      </PopUp>
    </div>
  );
}
